<template>
    <div class="header_wrap" :style="{'background-color':backgroundColor}">
        <div class="header">
            <div class="header_left">
                <span class="hello"
                    style="margin-right:0;">{{ $t('commonConfiguration.Description.hello') }}{{ b2bWebInfo.browserName }}</span>
                <!-- <span class="hello" v-if="locale == 'zh'">农业服务贸易全球商通中心</span>
                <span class="hello" v-if="locale == 'en'">Global Commerce Center for Agricultual Service Trade</span> -->
                <span class="register h1" v-if="!username"
                    @click="jumper('/login')">{{ $t('commonConfiguration.Button.login') }}</span>
                <span class="register h1" v-if="username">{{
                    username
                    }}</span>
                <span class="register h1" v-if="!username"
                    @click="jumper('/register')">{{ $t('commonConfiguration.Button.regist') }}</span>
                <span class="register h1" v-if="username"
                    @click="logout">{{ $t('commonConfiguration.Button.logout') }}</span>

            </div>
            <div class="header_right">
                <ul>
                    <li>
                        <div class="li_item" @click="toHref('/business', false, 'target')">
                            {{ $t('commonConfiguration.Button.button4') }}</div>
                    </li>
                    <li>
                        <div class="li_item" @click="toHref('/centerIndex', true)">
                            {{ $t('commonConfiguration.Button.button5') }}
                        </div>
                    </li>
                    <li>
                        <div class="li_item" @click="toHref('/purOrder', true)">
                            {{ $t('commonConfiguration.Button.button6') }}</div>
                    </li>
                    <li>
                        <el-dropdown placement="bottom-start">
                            <div class="li_item">{{ $t('commonConfiguration.Button.button3') }}</div>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item
                                        @click="toHref('/peomessage', true)">{{ $t('commonConfiguration.Button.button7') }}</el-dropdown-item>
                                    <el-dropdown-item
                                        @click="toHref('/Basicinfo', true)">{{ $t('commonConfiguration.Button.button8') }}</el-dropdown-item>
                                    <el-dropdown-item
                                        @click="toHref('/autManagement', true)">{{ $t('commonConfiguration.Button.button9') }}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>

                    </li>

                    <!-- <li style="width: 96px;"> -->
                        <!-- <el-dropdown placement="bottom-end" ref="dropdown">
                            <div class="li_item langStyle disflex">
                                <div v-if="locale == 'zh'">
                                    {{langArray.find(e => e.value == locale).label}}
                                </div>
                                <div v-else>
                                    {{langArray1.find(e => e.value == locale).label}}
                                </div>
                                <div>
                                    <el-icon style="font-size: 17px">
                                        <CaretBottom />
                                    </el-icon>
                                </div>
                            </div> -->

                            <!-- <div style="margin-top: 3px;">
                      <el-icon >
                      <CaretBottom />
                    </el-icon>
                    </div> -->
                            <!-- <template #dropdown>
                                <el-dropdown-menu v-if="!flag">
                                    <el-dropdown-item v-if="locale == 'zh'" v-for='(langLi, langIndex) in langArray'
                                        :key='langLi.value'
                                        @click='changeLang(langLi.value)'>{{ langLi.label }}</el-dropdown-item>
                                    <el-dropdown-item v-if="locale == 'en'" v-for='(langLi, langIndex) in langArray1'
                                        :key='langLi.value'
                                        @click='changeLang(langLi.value)'>{{ langLi.label }}</el-dropdown-item>
                                </el-dropdown-menu>
                            
                            </template>
                        </el-dropdown> -->

                    <!-- </li> -->
                    <li class="li">
                        <div class="li_item" @click="goPage('/toDo')">
                            我的待办
                      </div>
                      <el-badge v-if="todoNUm>0" class="mark" :value="todoNUm" :max="99" color="#FF403E" badge-style="height:16px;linne-height:16px"/> 
                    </li>
                     <li>
                        <div class="li_item" @click="getPlatInfo('/chat', true)">
                            平台客服
                      </div>
                    </li>
                    <li>
                        <div class="li_item" @click="openNewWindow(redirectUrl, true)">
                            <img src="../../view/shopDecoration/img/icon_head.png" alt="" />
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from "vue-router";
import { useI18n } from 'vue-i18n'
import lang from "@/lang";
import { useStore } from "vuex";
import operate from "../../view/shopDecoration/js/operate.js";
const { proxy } = getCurrentInstance();
const store = useStore();
const router = useRouter();
const props = defineProps({
    backgroundColor: {
        type:String,
        default:'#f2f2f2'
    }
});
const b2bWebInfo = computed(() => store.state.b2bWebInfo);
const { locale } = useI18n()
const username = ref(localStorage.getItem("userInfoB2B")?JSON.parse(localStorage.getItem("userInfoB2B")).user.loginName:'');
//监听localStorage.getItem("sznc_WebsiteUsername")变化
// 监听 storage 事件（其他标签页修改时触发）
const handleStorageChange = (e) => {
  if (e.key === 'userInfoB2B') {
    username.value = e.newValue?JSON.parse(e.newValue).user.loginName:'';
  }
};
const isEmptyOrEmptyObject = (v)=> {
  // 1. 先处理所有“空值”
  if (v == null) return true;            // null / undefined
  if (typeof v !== 'object') return !v;  // 原始类型：'', 0, false, NaN 都算空

  // 2. 再处理对象：数组、日期、正则等都不算“空对象”
  return Object.keys(v).length === 0;
}
const adminID = ref('')
adminID.value = !isEmptyOrEmptyObject(proxy.getConfig('chat'))?proxy.getConfig('chat').adminID:'';
// 重写 localStorage.setItem（当前标签页修改时触发）
const originalSetItem = localStorage.setItem;
localStorage.setItem = function (key, value) {
  originalSetItem.call(this, key, value);
  if (key === 'userInfoB2B') {
    username.value = value?JSON.parse(value).user.loginName:'';
  }
};
const changeLang = (lang) => {
    if (lang == locale.value) {
        return
    }
    proxy.$store.commit("localeB2B", lang);
    // locale.value = lang
    proxy.setCookie("lang", lang);
    // getSearchList()
    // flag.value=true
    // setTimeout(() => {
    //    flag.value=false
    // }, 500);
    location.reload()
}
const langArray = ref(lang.language)
const langArray1 = ref(lang.language1)
const preview = true;
const toHref = (e, t, jump) => {
    if (!preview) return;
    var localObj = window.location;
    if (jump == 'target') {
        proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + e);
    } else {
        if (t && !username.value) {
            // router.push({
            //     path: "/login",
            //     query: {},
            // });
            
            if(process.env.NODE_ENV=="test"){
              proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login"+'?redirect_url='+localObj.href);
            }else{
              proxy.tool.openWindow(proxy.redirectUrl+"/login?redirect_url="+localObj.href);
            }
            
        } else {
            router.push({
                path: e,
                query: {},
            });
        }
    }

};
const toPage = (e) => {
  let href = "";
  let str = "";
  if (e.type == "0") {
    // 无操作
  } else if (e.type == "1") {
    //
    href = e.data.href;
  } else {
    let operateLi = operate.find((l) => e.type == l.value);
    href = operateLi.href;
    e.inner = operateLi.inner;
    e.target = "1"
    if(operateLi.parameter&&operateLi.parameter.length>0){
      operateLi.parameter.forEach((element,index) => {
        let arr = element.value.split(',')
        let name =''
        if(arr.length>1){
          arr.forEach(m=>{
            if(!name){
              name = e.data[m]
            }
          })
        }else{
          name = e.data[element.value]
        }
        if(index==0){
          str += "?"+element.name+"=" + name
        }else{
          str += "&"+element.name+"=" + name
        }
      });
    }
  }
  openWindow(href, e.target, e.inner, str);
};

const jumper = (href) => {
  if (!preview) return;
  //toPage({ data: { href: href }, type: "1", inner: true });
  var localObj = window.location;
  
  if(process.env.NODE_ENV=="test"){
    proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx"+href+'?redirect_url='+localObj.href);
  }else{
    proxy.tool.openWindow(proxy.redirectUrl+href+"?redirect_url="+localObj.href);
  }
  
};
const openWindow = (href, target, inner, str) => {
  if (!href) return;
  if (target == "1") {
    // 当前页签打开
    router.push(href + str);
  } else {
    if (inner) {
      const url = router.resolve({
        path: href,
      });
      proxy.tool.openWindow(url.href + str);
    } else {
      proxy.tool.openWindow(href);
    }
  }
};

// 退出
function deleteCookie(name, path = '/', domain = "") {
    document.cookie = `${name}=; path=${path}; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
}
const logout = () => {
  //退出
  proxy
    .$request({
      method: "post",
      url: "SECURITY_W_LOGOUT",
      data: {},
    })
    .then((res) => {
      var data = res.data;
      if (data.code == "000") {
        proxy.setCookie("userInfoB2B", "");
        proxy.$store.commit("setUserInfoB2B", "");
        proxy.setCookie("membIdB2B", "");
        deleteCookie('wbf_access_token')
        var localObj = window.location;
        // openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href)
        if(process.env.NODE_ENV=="test"){
          window.location.href = localObj.protocol + "//" + localObj.host + "/nfstzx/login?redirect_url="+localObj.href
        }else{
          window.location.href = proxy.redirectUrl+"/login?redirect_url="+localObj.href
        }
        username.value = ''
      } else {
        proxy.$alert(data.msg || "系统错误...", "错误提示", {
          cofirmButtonText: "确定",
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const openNewWindow = (e) => {
  proxy.tool.openWindow(e);
}
const getPlatInfo = (url,t)=>{
  if (t && !username.value) {
        var localObj = window.location;
        if(process.env.NODE_ENV=="test"){
          proxy.tool.openWindow(localObj.protocol + "//" + localObj.host + "/nfstzx/login"+'?redirect_url='+localObj.href);
        }else{
          proxy.tool.openWindow(proxy.redirectUrl+"/login?redirect_url="+localObj.href);
        }
        
    } else {
      if(adminID.value){
        url+='?id='+adminID.value+'&sceneType=12&inboxType=10'
        proxy.tool.openWindow(url);
        return
      }
      proxy.$request({
        url:"B2B_N_PLAT_FINDDEFAULT",
        method: "post",
      }).then((res)=>{
        if(res.data.code=="000"){
          let result=res.data.result;
          adminID.value = result.platUserId
          url+='?id='+adminID.value+'&sceneType=12&inboxType=10'
          proxy.tool.openWindow(url);
        }
      }).catch((err)=>{
        console.log(err)
      })
    }
}
const goPage = (url)=>{
  router.push(url)
}
const todoNUm = ref(0)
const getNum = ()=>{
  proxy.$request({
        url:"B2B_BACKLOG",
        method: "post",
        data:{
            backlogSource:2
        }
    }).then((res)=>{
        console.log(res)
        if(res.data.code=='000'){
          todoNUm.value = res.data.result.backlogCount
        }
    }).catch((err)=>{
        console.log(err)
    })
}
getNum()
onMounted(async () => {
  window.addEventListener('storage', handleStorageChange);
});

onUnmounted(() => {
  localStorage.setItem = originalSetItem;
});
</script>

<style lang="less" scoped>
.li{
  .mark{
    top: -24px;
    left: 28px;
  }
}
.li_item:focus-visible{
  outline: none;
}
.li_item{
  height: 14px !important;
  img{
    width:14px;
    height: 14px;
  }
}
.disflex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>